import { render, staticRenderFns } from "./oftenFlow.vue?vue&type=template&id=324d6b0b&scoped=true&"
import script from "./oftenFlow.vue?vue&type=script&lang=js&"
export * from "./oftenFlow.vue?vue&type=script&lang=js&"
import style0 from "./oftenFlow.vue?vue&type=style&index=0&id=324d6b0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d6b0b",
  null
  
)

export default component.exports